import { z } from "zod/v4";
//#region src/schemas/space-mesh/continuity.ts
const continuitySchema = z.strictObject({
	messagesSinceThen: z.number().int().finite().min(0),
	higherAuthorityUpdates: z.boolean()
});
//#endregion
export { continuitySchema };

//# sourceMappingURL=continuity.js.map